var exports = {
  "R": "xdde3148b--c00584--heading",
};

module.exports = exports;
